
import {sharedStore} from "../framework/sharedStore.js";
import {$} from "../util/seq.js";
import {sessionStore} from "../framework/sessionStore.js";
import {modalStore} from "../framework/modalStore.js";
import {debounce} from "../lib/underscore.js";

/**
 * @param {EarthClient} client
 * @param {EarthServer} server
 * @param agents
 * @param inputController
 */
export function defineClientNotifier(client, server, agents, inputController) {
    if (!client) {
        return;
    }

    const {primaryLayerAgent, overlayLayerAgent, annotationLayerAgent, fieldAgent} = agents;
    sharedStore.on($`change`, (delta, old, meta) => client.stateChanged(delta, old, meta));
    sessionStore.on($`change`, (delta, old, meta) => client.stateChanged(delta, old, meta));
    modalStore.on($`change`, (delta, old, meta) => client.stateChanged(delta, old, meta));

    const notifyLayerChange = debounce(() => {
        client.layersChanged(server.getLayers());
    });

    primaryLayerAgent.on($`update`, notifyLayerChange);
    overlayLayerAgent.on($`update`, notifyLayerChange);
    annotationLayerAgent.on($`update`, notifyLayerChange);

    function notifyClick(point, coords) {
        const x = +point[0];
        const y = +point[1];
        const λ = +coords[0];
        const φ = +coords[1];
        const field = fieldAgent.value();
        // UNDONE: the globe/projection should have the isInsideBoundary function instead of the field (because there
        //         are many fields, one per layer, but only one globe/projection.
        if (x === x && y === y && λ === λ && φ === φ && field?.isInsideBoundary(x, y)) {
            client.click([x, y], [λ, φ]);
        }
    }

    inputController.on($`click`, notifyClick);
}
